import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Center,
} from "@chakra-ui/react";
import { FaFacebook } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { useForm } from "react-hook-form";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import Nav from "../NavBar";
import { useState } from "react";

const googleAuthProvider = new GoogleAuthProvider();

export default function SigninPage() {
  const { register, handleSubmit } = useForm();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const afterAuth = () => navigate("/");

  const signIn = async (data) => {
    setSubmitting(true);
    signInWithEmailAndPassword(getAuth(), data.email, data.password)
      .then(afterAuth)
      .catch((error) => {
        setSubmitting(false);
        console.error(error);
        const msg =
          {
            "auth/wrong-password": "Incorrect password, please try again.",
            "auth/invalid-email": "Invalid email, please try again.",
            "auth/user-not-found": "No account found with that email",
          }[error.code] || "Something went wrong. Please try again.";
        setError(msg);
      });
  };

  return (
    <Flex direction={"column"} minH={"100vh"}>
      <Nav />
      <Flex minH={"100%"} align={"center"} justify={"center"}>
        <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
          <Stack align={"center"}>
            <Heading fontSize={"4xl"}>Sign in to your account</Heading>
            <Text fontSize={"lg"} color={"gray.600"}>
              to enjoy all of our cool features ✌️
            </Text>
          </Stack>
          <Box
            rounded={"lg"}
            bg={useColorModeValue("white", "gray.700")}
            boxShadow={"lg"}
            p={8}
          >
            <form onSubmit={handleSubmit(signIn)}>
              <Stack spacing={4}>
                <FormControl id="email">
                  <FormLabel>Email address</FormLabel>
                  <Input {...register("email")} type="email" required />
                </FormControl>
                <FormControl id="password">
                  <FormLabel>Password</FormLabel>
                  <Input {...register("password")} type="password" required />
                </FormControl>
                <Stack spacing={10}>
                  {/* <Stack
                direction={{ base: "column", sm: "row" }}
                align={"start"}
                justify={"space-between"}
              >
                <Checkbox>Remember me</Checkbox>
                <Link color={"blue.400"}>Forgot password?</Link>
              </Stack> */}
                  <Stack spacing={2}>
                    {error && <Text color={"red.600"}>{error}</Text>}
                    <Button
                      type="submit"
                      bg={"blue.400"}
                      color={"white"}
                      _hover={{
                        bg: "blue.500",
                      }}
                      isLoading={submitting}
                    >
                      Sign in
                    </Button>
                    <Text
                      textAlign={"center"}
                      fontWeight={"semibold"}
                      opacity={0.8}
                    >
                      or
                    </Text>
                    <Button
                      w={"full"}
                      maxW={"md"}
                      variant={"outline"}
                      leftIcon={<FcGoogle />}
                      onClick={() => {
                        setSubmitting(true);
                        signInWithPopup(getAuth(), googleAuthProvider).then(
                          afterAuth
                        );
                      }}
                    >
                      <Center>
                        <Text>Sign in with Google</Text>
                      </Center>
                    </Button>
                    {/* <Button
                      w={"full"}
                      maxW={"md"}
                      colorScheme={"facebook"}
                      leftIcon={<FaFacebook />}
                    >
                      <Center>
                        <Text>Continue with Facebook</Text>
                      </Center>
                    </Button> */}
                  </Stack>
                </Stack>
              </Stack>
            </form>
          </Box>
        </Stack>
      </Flex>
    </Flex>
  );
}
